import { Box, Typography } from "@mui/material";
import React from "react";
import TransferList from "./TransferList";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { setState } from "./editScenarioNewSlice";

export default function SkuPgSearchResult() {
	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.editScenarioNew);
	const { productGroups, selectedPGs, editScDetails, is_sku_refresh } = setupState;

	useEffect(() => {
		if (editScDetails !== null) {
			// let tempPGs = [];
			// editScDetails.productGroup.forEach((item) => {
			// 	console.log(item);
			// 	tempPGs.push(item.productGroup);
			// });
			// editScDetails.product.forEach((item) => {
			// 	console.log(item);
			// 	tempPGs.push(item.product);
			// });
			// dispatch(setState("selectedPGs", tempPGs));
		}
	}, [editScDetails]);
	return (
		<Box
			sx={{
				mt: 2,
				p: 2,
				border: 1,
				borderRadius: 1,
				borderColor: "#bcbcbc",
			}}
		>
			<Box sx={{}}>
				<Typography variant="subtitle1"></Typography>
			</Box>

			<Box container columns={12} justifyContent="space-between" alignItems="center" spacing={1} mt={2}>
				<TransferList 
					leftList={productGroups}
					rightList={selectedPGs}
					leftState={"productGroups"}
					rightState={"selectedPGs"}
					isCustomer = {false}
					refresh = {is_sku_refresh}
				/>
			</Box>
		</Box>
	);
}
